import { API_BASE, authHeaders, parseJson } from "./client";

export async function uploadErganiXml(file) {
  const body = new FormData();
  body.append("file", file);
  const headers = authHeaders();
  delete headers["Content-Type"];
  const res = await fetch(`${API_BASE}/ergani/xml`, { method: "POST", headers, body });
  return parseJson(res);
}

export async function fetchErganiImports(limit = 8, { signal } = {}) {
  const res = await fetch(`${API_BASE}/ergani/imports?limit=${limit}`, { headers: authHeaders(), signal });
  return parseJson(res);
}

export async function fetchErganiSlots(storeName, weekStart, { signal, unifiedLocationId = null } = {}) {
  const params = new URLSearchParams({ week_start: weekStart || "" });
  if (unifiedLocationId != null) params.set("unified_location_id", String(unifiedLocationId));
  else params.set("store_name", storeName || "");
  const res = await fetch(`${API_BASE}/ergani/slots?${params}`, { headers: authHeaders(), signal });
  return parseJson(res);
}

export async function fetchErganiHistory(employeeCode, date) {
  const params = new URLSearchParams({
    employee_code: employeeCode || "",
    date: date || "",
  });
  const res = await fetch(`${API_BASE}/ergani/slots/history?${params}`, { headers: authHeaders() });
  return parseJson(res);
}
